import React from 'react';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import useAudioServerCommunication from './useAudioServerCommunication';

export default function useHandleDetection() {
  const { lastJsonMessage } = useAudioServerCommunication();
  const { sessionId: [sessionId], latestDetection: [, setLatestDetection] } = useSessionStoreContext();
  const sessionIdRef = React.useRef(sessionId);

  React.useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.type === 'detection') {
      setLatestDetection(lastJsonMessage.message.detection);
    }
  }, [lastJsonMessage]);

  React.useEffect(() => {
    if (sessionId !== sessionIdRef.current) {
      setLatestDetection(null);
    }
    sessionIdRef.current = sessionId;
  }, [sessionId]);
}
